import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class FileDownloadService {

  constructor() { }

  abstract downloadAndOpen(url: string, filename: string, content_type: string, skipAuth?: boolean):Observable<any>;
}
